import { useState, useEffect } from 'react';
import { FileText, Download, Calendar, RefreshCw } from 'lucide-react';
import { PageShell, FG, SEL, Row2, BtnPrimary, Spinner, fmtINR, fmtDate, useBanner, useWalletUser, EmptyState } from './WalletShared';
import walletController from '../../controllers/walletController';

const Statements = () => {
  const { userId } = useWalletUser();
  const { banner, notify, clearBanner } = useBanner();
  const [statements, setStatements] = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [filters,    setFilters]    = useState({ month:'', year:new Date().getFullYear() });

  const load = async () => {
    setLoading(true);
    const res = await walletController.getStatements(userId, filters);
    if (res.success) setStatements(res.data);
    else notify('error', res.message);
    setLoading(false);
  };
  useEffect(() => { load(); }, [userId, filters]);

  const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const years  = Array.from({ length:5 }, (_,i) => new Date().getFullYear()-i);

  return (
    <PageShell title="Statements" subtitle="Monthly wallet statements" icon={FileText}
      banner={banner} onCloseBanner={clearBanner}>

      {/* Filters */}
      <div style={{ display:'flex', gap:10, marginBottom:20, alignItems:'flex-end', flexWrap:'wrap' }}>
        <div>
          <div style={{ fontSize:11, color:'#64748b', marginBottom:4, fontWeight:600, textTransform:'uppercase' }}>Month</div>
          <SEL value={filters.month} onChange={e => setFilters(p => ({ ...p, month:e.target.value }))} style={{ width:140 }}>
            <option value="">All months</option>
            {MONTHS.map((m,i) => <option key={i} value={i+1}>{m}</option>)}
          </SEL>
        </div>
        <div>
          <div style={{ fontSize:11, color:'#64748b', marginBottom:4, fontWeight:600, textTransform:'uppercase' }}>Year</div>
          <SEL value={filters.year} onChange={e => setFilters(p => ({ ...p, year:Number(e.target.value) }))} style={{ width:120 }}>
            {years.map(y => <option key={y} value={y}>{y}</option>)}
          </SEL>
        </div>
      </div>

      {loading
        ? <div style={{ display:'flex', justifyContent:'center', padding:'50px 0', gap:10, color:'#64748b' }}><Spinner size={24}/></div>
        : statements.length===0
          ? <EmptyState icon={FileText} message="No statements found for this period"/>
          : (
            <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
              {statements.map((s,i) => (
                <div key={i} style={{ background:'#fff', borderRadius:12, border:'1px solid #f1f5f9', padding:'16px 20px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:12 }}>
                    <div style={{ width:42, height:42, borderRadius:10, background:'#eff6ff', display:'flex', alignItems:'center', justifyContent:'center' }}>
                      <FileText size={18} color="#3b82f6"/>
                    </div>
                    <div>
                      <div style={{ fontSize:14, fontWeight:700, color:'#1e293b' }}>{s.label||`${MONTHS[(s.month||1)-1]} ${s.year}`} Statement</div>
                      <div style={{ fontSize:12, color:'#94a3b8', display:'flex', gap:16, marginTop:2 }}>
                        <span>Opening: {fmtINR(s.openingBalance)}</span>
                        <span>Closing: {fmtINR(s.closingBalance)}</span>
                        <span>{s.totalTransactions||0} transactions</span>
                      </div>
                    </div>
                  </div>
                  <div style={{ display:'flex', gap:10, alignItems:'center' }}>
                    <div style={{ textAlign:'right' }}>
                      <div style={{ fontSize:11, color:'#64748b' }}>Net Flow</div>
                      <div style={{ fontSize:15, fontWeight:700, color:(s.closingBalance-s.openingBalance)>=0?'#15803d':'#b91c1c' }}>
                        {(s.closingBalance-s.openingBalance)>=0?'+':''}{fmtINR(s.closingBalance-s.openingBalance)}
                      </div>
                    </div>
                    {s.downloadUrl && (
                      <a href={s.downloadUrl} style={{ display:'flex', alignItems:'center', gap:5, padding:'7px 12px', background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:7, fontSize:12, color:'#475569', textDecoration:'none' }}>
                        <Download size={13}/>PDF
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
    </PageShell>
  );
};
export default Statements;